import { getI18n } from 'react-i18next';

export const VALIDATION_AUCTIONEER_DATA_DUPLICATE_MEMBER_SUBMARKET_COMBINATION = 'validation.auctioneerData.duplicateMemberSubmarketCombination';
export const VALIDATION_AUCTIONEER_DATA_INVALID_SUBMARKET = 'validation.auctioneerData.invalidSubmarket';
export const VALIDATION_AUCTIONEER_DATA_INVALID_MEMBER = 'validation.auctioneerData.invalidMember';
export const VALIDATION_AUCTIONEER_DATA_NEGATIVE_CELL_VALUE = 'validation.auctioneerData.negativeCellValue';
export const VALIDATION_AUCTIONEER_DATA_INVALID_QUANTITY_SUM = 'validation.auctioneerData.invalidQuantitySum';
export const VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_MEMBER = 'validation.auctioneerData.item.invalidMember';
export const VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_SUBMARKET = 'validation.auctioneerData.item.invalidSubmarket';
export const VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_QUANTITY = 'validation.auctioneerData.item.invalidQuantity';

export const createAuctioneerDataMatrixErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_AUCTIONEER_DATA_DUPLICATE_MEMBER_SUBMARKET_COMBINATION:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-duplicate-member-submarket-combination');
            break;
        case VALIDATION_AUCTIONEER_DATA_INVALID_QUANTITY_SUM:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-invalid-quantity-sum');
            break;
        case VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_MEMBER:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-item-invalid-member');
            break;
        case VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_SUBMARKET:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-item-invalid-submarket');
            break;
        case VALIDATION_AUCTIONEER_DATA_MATRIX_ITEM_INVALID_QUANTITY:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-item-invalid-quantity');
            break;
        case VALIDATION_AUCTIONEER_DATA_INVALID_SUBMARKET:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-invalid-submarket', params);
            break;
        case VALIDATION_AUCTIONEER_DATA_INVALID_MEMBER:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-invalid-member', params);
            break;
        case VALIDATION_AUCTIONEER_DATA_NEGATIVE_CELL_VALUE:
            result = i18n.t('auctioneer-data-matrix.error.auctioneer-data-matrix-negative-cell-value', params);
            break;
        default:
            result = undefined;
    }
    return result;
};
